import { DataBean } from "../DataBean";

export class SignCashRequest extends DataBean {


    public async signCashRequest(idCashRequest:any,cashRequestDate:any,idSignAndApprovalPanel:any,idEmployee:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "String_signCashRequest_Number_java.util.Date_Number_Number", [idCashRequest,cashRequestDate,idSignAndApprovalPanel,idEmployee]);
    }

}